import { Modal } from "antd";

export const STORE_ORDER_CREATE_RESULT_DUPLICATE_UNPAID = 506;

export type DuplicateUnpaidOrderAction = "new" | "pay";

const DUPLICATE_UNPAID_MSG = "您已经有一个相同产品的订单尚未支付，确定要新建订单吗？";

export function promptDuplicateUnpaidOrder(
  messageText: string = DUPLICATE_UNPAID_MSG
): Promise<DuplicateUnpaidOrderAction> {
  return new Promise((resolve) => {
    Modal.confirm({
      title: null,
      icon: null,
      content: messageText,
      width: 360,
      centered: true,
      maskClosable: false,
      closable: false,
      cancelText: "新建订单",
      okText: "前往支付",
      onCancel: () => resolve("new"),
      onOk: () => resolve("pay"),
    });
  });
}

export function isDuplicateUnpaidCreateResult(res: {
  createResult: number;
  existingOrderId?: string | null;
}): res is { createResult: typeof STORE_ORDER_CREATE_RESULT_DUPLICATE_UNPAID; existingOrderId: string } {
  return (
    res.createResult === STORE_ORDER_CREATE_RESULT_DUPLICATE_UNPAID &&
    Boolean(res.existingOrderId?.trim())
  );
}
